{% block ecocode_trustpilot_sender_config %}
    <div class="sender-email-config-wrapper">
        <div class="email-switch">
            <sw-switch-field
                :label="$tc('ecocode-trustpilot.config.showSenderLabel')"
                v-model:value="currentValue.useCustom"
                name="showSender"
                v-bind="$attrs"
            >
            </sw-switch-field>
            <ecocode-trustpilot-danger-text class="sw-field__help-text"
                                            :text="$tc('ecocode-trustpilot.config.showSenderInfo')"></ecocode-trustpilot-danger-text>
        </div>
        <template v-if="currentValue.useCustom">
            <p>
                {{ $tc('ecocode-trustpilot.config.senderSetupLabel') }} <a
                    href="https://support.trustpilot.com/hc/de/articles/201814737" target="_blank"
                    rel="noopener">{{ $tc('ecocode-trustpilot.config.senderSetupLink') }}</a>
            </p>
            <div>
                <ecocode-trustpilot-info-text :text="$tc('ecocode-trustpilot.config.senderSetupInfo')"/>
                <ecocode-trustpilot-email-config
                    name="sender"
                    :label="$tc('ecocode-trustpilot.config.senderLabel')"
                    v-bind="$attrs"
                    placeholder="noreply.invitations@trustpilotmail.com"
                    v-model:value="currentValue.sender">
                </ecocode-trustpilot-email-config>
            </div>
        </template>
    </div>
{% endblock %}
